import { assert_false, assert_not_null } from '@shared/asserts/utils_asserts';
import { ENUM__control_net_type } from '@shared/dto/+model/sd/_enums/ENUM__control_net_type';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../../_fields/_base/FIELD__base';
import { ENUM__invocation_role as ENUM } from '../../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_SD__denoise_latents_pipeline } from '../../../_invocations/sd/denoise/INVOCATION_SD__denoise_latents_pipeline';
import { INVOCATION_SD__control_net } from '../../../_invocations/sd/guidance/INVOCATION_SD__control_net';
import { ENUM__graph_template_name } from '../ENUM__graph_template_name';

export function GENERATION_TOOL__sd1__canny(tool: DTO__generation_tool) {
  let { graph } = tool;

  assert_not_null(graph);
  assert_false(graph.is_stub());

  /*
   *
   */
  let node__denoise = INVOCATION_SD__denoise_latents_pipeline.create_node_for(graph, ENUM.CORE__DENOISE);

  /*
   * CONTROL NET CANNY
   */

  let node__control = INVOCATION_SD__control_net.create_node_for(graph, ENUM.CONTROL___CANNY);
  node__control.control_net.type.set_value(ENUM__control_net_type.LINE_GUIDANCE_CANNY);

  if (!graph.nodes__are_connected_directly(node__control.meta.node_id, node__denoise.meta.node_id)) {
    graph.edge__try_add_for_fields(node__control.control_net, node__denoise.control);
  }

  /*
   * UI
   */

  let fields__visible: FIELD__base[] = [node__control.control_net.image, node__control.control_net.weight];
  let field_column_id = node__control.control_net.weight.meta.field_id;

  tool.view__add({
    name: ENUM__graph_template_name.TUNE_LINES,
    group: '2. Control',

    //
    fields__visible,
    fields__stored: fields__visible,
    //
    field_column_id,
    //
    field_id_info__has_affect_on_generation: node__control.control_net.image.meta.field_id,
  });
}
